import { default as Image } from '@react/shared/components/Image';
import Heading from 'sly/system/Heading';

export interface HubHeaderProps {
  imagePath: string;
  heading: string;
  label: string;
}

function HubHeader({
  imagePath,
  heading,
  label,
}: {
  imagePath: string;
  heading: string;
  label: string;
}) {
  return (
    <div
      className='relative flex w-full'
      data-tp-id='gen-div-0a0aeb97-4baa-406c-af67-76841cfe1b2c'
    >
      <Image
        path={imagePath}
        alt={heading}
        layout='fill'
        objectFit='cover'
        priority
        data-tp-id='gen-Image-101bf7e3-a415-4658-8bef-18dffeee8e02'
      />
      <div
        className='z-[1] flex h-full max-h-[21.5rem] w-full items-center justify-center bg-[rgba(0,0,0,0.4)] [aspect-ratio:16/9]'
        data-tp-id='gen-div-050523cc-fcd6-4957-bbcc-70d46bd906ac'
      >
        <div
          className='flex w-full flex-col px-xxl pb-xxl pt-xxxl md:w-[var(--col6)] md:py-xxxl md:px-0 lg:w-[var(--col8)]'
          data-tp-id='gen-div-2e98a8cd-3982-4ca6-9891-638a3cf2adc9'
        >
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/*@ts-ignore*/}
          <Heading
            as='h1'
            font='font-t-xl'
            className='mb-6 text-white md:mb-l'
            data-tp-id='gen-Heading-41f56398-565b-465a-98e4-7a6362196e34'
          >
            {heading}
          </Heading>
          <p className='font-b-l text-white'>{label}</p>
        </div>
      </div>
    </div>
  );
}

export default HubHeader;
